import { render, staticRenderFns } from "./LabelRegionTestModel.vue?vue&type=template&id=7033f9c8&scoped=true&"
import script from "./LabelRegionTestModel.vue?vue&type=script&lang=js&"
export * from "./LabelRegionTestModel.vue?vue&type=script&lang=js&"
import style0 from "./LabelRegionTestModel.vue?vue&type=style&index=0&id=7033f9c8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7033f9c8",
  null
  
)

export default component.exports